import { createLabeledMessages, unitJoin } from '../../../messageUtils';
const car = {
    registrationNumber: 'registračná značka',
    registrationNumber_short: 'RZ',
    vin: 'VIN',
    technicalCertificateCard: 'technický preukaz',
    technicalCertificateCard_short: 'TP',
    technicalCertificate: 'veľký technický preukaz',
    technicalCertificate_short: 'VTP',
    type: 'druh',
    usage: 'použitie',
    engineCapacity: 'objem',
    engineCapacityCcm: unitJoin('car:engineCapacity_label', 'ccm'),
    weight: 'hmotnosť',
    weightKg: unitJoin('car:wight', 'kg'),
    startDate: 'dátum uvedenia do prevádzky',
    model: 'model',
    manufacturer: 'výrobca',
    body: 'karoséria',
    door: 'dvere',
    manufacturedFrom: 'výrobené z',
    manufacturedTo: 'výrobené do',
    seedCount: 'počet miest',
    transmission: 'prevodovka',
    fuel: 'palivo',
    pov: 'povinné zmluvné poistenie',
    poc_short: 'PZP',
    hav: 'havarijné poistenie',
    hav_short: 'HAV'
};
export default Object.assign({}, car, createLabeledMessages(car));
